<template>
  <SyncDataConfirmModal
    v-if="showSyncDataConfirmModal"
    :allDataSelected="allDataSelected"
    :dataSync="dataSelected"
    @closeModal="closeShowSyncDataConfirmModal"
  />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Sincronização de Dados</h4>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <div v-else class="card-body">
      <div class="alert alert-info border-0">
        Quantidade de registros: {{ listData.length }} | Quantidade de registros
        selecionados: {{ dataSelected.length }}
      </div>
      <div class="table-responsive mb-3">
        <table class="table table-sm table-bordered fs-sm">
          <thead>
            <tr>
              <th class="text-center">
                <input
                  type="checkbox"
                  class="form-check-input cp"
                  title="Selecionar Todos"
                  v-model="allDataSelected"
                  value="true"
                />
              </th>
              <th>Código da Setença</th>
              <th>Título</th>
              <th>Data Última Sincronização</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in listData" :key="data.codSentenca">
              <td class="text-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="dataSelected"
                  :value="data"
                />
              </td>
              <td>{{ data.codSentenca }}</td>
              <td>{{ data.titulo }}</td>
              <td>{{ dateISOToDateBR(data.ultSync) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="alert alert-info border-0">
        Quantidade de registros: {{ listData.length }} | Quantidade de registros
        selecionados: {{ dataSelected.length }}
      </div>
      <div class="text-end">
        <button
          class="btn btn-dark"
          title="Sincronizar Dados"
          @click="showSyncDataConfirm"
        >
          Sincronizar Dados
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SyncDataConfirmModal from '@/components/company/sync/SyncDataConfirmModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { dateISOToDateBR } from '@/utils/date'

export default {
  name: 'SyncData',

  components: {
    SyncDataConfirmModal,
    LoadingData,
  },

  data() {
    return {
      isLoadingData: true,
      listData: [],
      allDataSelected: false,
      dataSelected: [],
      showSyncDataConfirmModal: false,
      dateISOToDateBR,
    }
  },

  watch: {
    allDataSelected: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.dataSelected = this.listData.map((data) => data)
        } else {
          this.dataSelected = []
        }
      },
      immediate: true,
    },
  },

  methods: {
    async getSyncData() {
      try {
        this.listData = await this.$store.dispatch('getSyncData')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    showSyncDataConfirm() {
      if (this.dataSelected.length === 0) {
        this.$root.$refs.notification.warning(
          'E necessário selecionar pelos menos um registro.',
        )
        return
      }
      this.showSyncDataConfirmModal = true
    },

    closeShowSyncDataConfirmModal(needReload) {
      if (needReload) {
        this.getSyncData()
        this.allDataSelected = false
        this.dataSelected = []
      }
      this.showSyncDataConfirmModal = false
    },
  },

  mounted() {
    this.getSyncData()
  },
}
</script>
